const throwErrorAction = (message: string) => {
  throw new Error(message);
};

export default throwErrorAction;
